import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import { reduxForm, Field } from 'redux-form'

import { localize } from 'helpers/translator'
import { validateEmail } from 'helpers/validations'
import TextInputForm from 'components/input/text/text_input_form'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import SelectFormDropdown from 'components/select/select_form'
import { MainButton } from 'components/button'

import styles from './admin_onboarding_refer_contact_form.scss'

const roles = [
	{value: 'Assistant Principal', text: 'Assistant Principal'},
	{value: 'Principal', text: 'Principal'},
]

const validate = (values, props) => {
	const errors = {}
	if (!values.firstName) {
		errors.firstName = localize('global_form_firstNameIsRequired')
	}
	if (!values.lastName) {
		errors.lastName = localize('global_form_lastNameIsRequired')
	}
	if (!values.email) {
		errors.email = localize('global_form_emailIsRequired')
	} else if (!validateEmail(values.email)) {
		errors.email = localize('global_form_invalidEmail')
	}
	if (!values.role) {
		errors.role = localize('global_form_rolIsRequired')
	}
	if (!values.phoneNumber && props.phoneNumberRequired) {
		errors.phoneNumber = localize('admin_onboarding_contact_form_phone_is_required')
	}
	return errors
}

class AdminOnboardingLearnMoreForm extends PureComponent {

	constructor() {
		super()
		this.formSubmitHandler = this.formSubmitHandler.bind(this)
	}

	formSubmitHandler(values) {
		this.props.sendEmailToDM(values)
	}

	getSendButtonMessage() {
		return this.props.sendButtonText || localize('admin_onboarding_refer_button')
	}

	getFieldMessage(field) {
		return field.error
	}

	getFieldStatus(field) {
		if (field.touched /*&& !(field.active)*/) {
			if (field.invalid) {
				return 'error'
			} else {
				return 'success'
			}
		} else {
			return ''
		}
	}

	render() {
		const {
			error,
			submitting } = this.props

		const phoneNumberText = this.props.phoneNumberRequired ? localize('admin_onboarding_contact_form_phone_placeholder') : localize('admin_onboarding_contact_form_phone_number')
		return (
			<div styleName='wrapper'>
				<div styleName='header'>
					<SecondaryTitle isCentered={true}>{localize(this.props.isTrialFromSF ? 'admin_onboarding_refer_title_sf' : 'admin_onboarding_refer_title')}</SecondaryTitle>
					<h3 styleName='subtitle'>{localize('admin_onboarding_refer_subtitle')}</h3>
				</div>
				<div>
					<form styleName='form' id='contactForm' onSubmit={this.props.handleSubmit(this.formSubmitHandler)}>
						<div styleName='two-cols'>
							<div styleName='field'>
								<label styleName='field-label'>{localize('admin_onboarding_contact_form_first_name')}</label>
								<Field
									name="firstName"
									component={TextInputForm}
									type="text"
									props={{
										tabIndex: 1,
										fieldStatus: this.getFieldStatus,
										getMessage: this.getFieldMessage,
									}}

								/>
							</div>
							<div styleName='field'>
								<label styleName='field-label'>{localize('admin_onboarding_contact_form_last_name')}</label>
								<Field
									name="lastName"
									component={TextInputForm}
									type="text"
									props={{
										tabIndex: 2,
										fieldStatus: this.getFieldStatus,
										getMessage: this.getFieldMessage,
									}}

								/>
							</div>
						</div>
						<div styleName='field'>
							<label styleName='field-label'>{localize('admin_onboarding_contact_form_email')}</label>
							<Field
								name="email"
								component={TextInputForm}
								type="text"
								props={{
									tabIndex: 3,
									fieldStatus: this.getFieldStatus,
									getMessage: this.getFieldMessage,
								}}
							/>
						</div>
						<div styleName='field'>
							<label styleName='field-label'>{phoneNumberText}</label>
							<Field
								name="phoneNumber"
								component={TextInputForm}
								type="text"
								props={{
									tabIndex: 4,
									fieldStatus: this.getFieldStatus,
									getMessage: this.getFieldMessage,
								}}
							/>
						</div>
						<div styleName='field'>
							<label styleName='field-label'>{localize('admin_onboarding_contact_form_role_title')}</label>
							<Field
								name={'role'}
								component={SelectFormDropdown}
								props={{
									tabIndex: 5,
									submitting,
									fontSize: 'medium',
									options: roles,
									placeholder: localize('admin_onboarding_contact_form_role_title_placeholder'),
									fieldStatus: this.getFieldStatus,
									getMessage: this.getFieldMessage,
								}}
							/>
						</div>
						<div styleName='btn-bar'>
							<div styleName='btn-bar-button'>
								<MainButton tabIndex={6} focus={true} type='submit'>{this.getSendButtonMessage()}</MainButton>
								{error && <div >{error}</div>}
							</div>
						</div>
					</form>
				</div>
			</div>
		)
	}
}

AdminOnboardingLearnMoreForm.defaultProps = {
	sendButtonText: '',
	phoneNumberRequired: false,
}

AdminOnboardingLearnMoreForm.propTypes = {
	fontSize: PropTypes.oneOf(['small', 'medium', 'big']),
	phoneNumberRequired: PropTypes.bool,
}

const DecoratedAdminOnboardingLearnMoreForm = reduxForm({
	form: 'ContactForm',
	fields: ['firstName', 'lastName', 'email', 'phoneNumber', 'role'],
	validate,
})(CSSModules(AdminOnboardingLearnMoreForm, styles, {allowMultiple: true}))

export default (DecoratedAdminOnboardingLearnMoreForm)
